import $ from 'jquery';
import 'modernizr';
import 'fg-loadcss/src/cssrelpreload';
import InitializerEventDispatcher from './utils/InitializerEvent';
import Language from './utils/Language';
import initLayout from "./components/Layout";
import SvgSpriteExporter from "./utils/SvgSpriteExporter";

window.SuggestionUserList = (data) => {
    const item = document.createElement('DIV');

    item.classList.add('element--flex');
    item.classList.add('element--flex-center');
    item.classList.add('element--flex-items--center');

    if ('firstName' in data && 'lastName' in data) {
        item.appendChild(
            document.createTextNode(`${data.firstName} ${data.lastName}`)
        );
    }

    if ('companyName' in data && data.companyName !== null) {
        item.appendChild(document.createTextNode(`(${data.companyName})`));
    }

    return item;
};

window.SuggestionOrderList = (data) => {
    const item = document.createElement('div');

    item.classList.add('element--flex');

    const div = document.createElement('div');
    div.classList.add('element--bold', 'element--flex-1');

    const createdAt = new Date(data.createdAt * 1000);

    div.appendChild(
        document.createTextNode(
            `#${data.requestId} / ${Language.formatDateTime(createdAt)}`
        )
    );

    item.appendChild(div);

    if ('user' in data && 'firstName' in data.user && 'lastName' in data.user) {
        let createdByString = `${Language.t('orders.created_by')} ${data.user.firstName} ${data.user.lastName}`;

        if ('company' in data && data.company.name.length > 0) {
            createdByString = `${createdByString} / ${data.company.name}`;
        }

        item.appendChild(document.createTextNode(createdByString));
    }

    return item;
};

window.SuggestionProductOptionsList = (data) => {
    const buildCheckbox = (id, name, label, checked) => {
        const input = document.createElement('input');

        const inputId = `ramdomId${id}${Math.floor(Math.random() * 1000000000)}`;

        input.setAttribute('id', inputId);
        input.setAttribute('type', 'checkbox');
        input.setAttribute('name', name);
        input.setAttribute('value', '1');

        if (checked) {
            input.setAttribute('checked', 'checked');
        }

        const div = document.createElement('DIV');

        div.classList.add('padding-top-1');
        div.classList.add('element--flex');
        div.classList.add('element--flex-items--center');
        div.classList.add('element--flex-nowrap');

        div.appendChild(input);

        const labelNode = document.createElement('label');
        labelNode.setAttribute('for', inputId);
        labelNode.appendChild(document.createTextNode(label));
        div.appendChild(labelNode);

        return div;
    };

    const item = document.createElement('DIV');

    item.classList.add('element--flex');
    item.classList.add('element--flex-row-wrap');
    item.classList.add('element--flex-items--center');

    const dragHandle = document.createElement('div');
    dragHandle.innerHTML = SvgSpriteExporter('icon_dragdrop', 'drag-handle margin-right-1 element--flex element--flex-items--center ');
    item.appendChild(dragHandle.firstChild);

    const optionId = `optionId${Math.ceil(Math.random() * 1000000000)}`;

    const div = document.createElement('DIV');

    div.classList.add('padding-vcenter-1');
    div.classList.add('element--flex-0');

    div.appendChild(document.createTextNode(data.name));

    div.appendChild(
        buildCheckbox(
            optionId,
            `data[option][${optionId}][isRequired]`,
            Language.t('product_options.group.option_is_required'),
            data.isRequired
        )
    );
    div.appendChild(
        buildCheckbox(
            optionId,
            `data[option][${optionId}][isAffectingPrice]`,
            Language.t('product_options.group.option_is_affecting_price'),
            data.isAffectingPrice
        )
    );
    div.appendChild(
        buildCheckbox(
            optionId,
            `data[option][${optionId}][isVisibleInList]`,
            Language.t('product_options.group.option_is_visible_in_list'),
            data.isVisibleInList
        )
    );
    item.appendChild(div);

    const idInput = document.createElement('input');
    idInput.setAttribute('id', `ramdomId${optionId}`);
    idInput.setAttribute('type', 'hidden');
    idInput.setAttribute('name', `data[option][${optionId}][id]`);
    idInput.setAttribute('value', data.id);

    item.appendChild(idInput);

    return item;
};

window.SuggestionSortableList = (data) => {
    const item = document.createElement('div');

    item.classList.add('element--flex');
    item.classList.add('element--flex-row-wrap');
    item.classList.add('element--flex-items--center');

    const dragHandle = document.createElement('div');
    dragHandle.innerHTML = SvgSpriteExporter('icon_dragdrop', 'drag-handle margin-right-1 element--flex element--flex-items--center');
    item.appendChild(dragHandle.firstChild);

    const div = document.createElement('DIV');

    div.classList.add('padding-vcenter-1');
    div.classList.add('element--bold');
    div.classList.add('element--flex-0');

    div.appendChild(document.createTextNode(data.name));

    item.appendChild(div);

    return item;
};

/**
 * Open visual editor
 *
 * I add it in window object because I need to access it when receive RequestResponse.
 * @param url
 */
window.openPageEditor = (url) => {
    // Create loading
    $('body').append(`
        <div id="page-builder-loading"
              class="loading loading--circle loading--overlay loading--solid">
            <div class="pulse animated infinite font-size-8 element--bold margin-bottom-4">
                ${Language.t('themes.loading_visual_editor')}
            </div>
        </div>
    `);

    document.body.classList.add('js-page-has-active-page-builder');
    document.body.classList.add('js-page-has-active-sidebar');

    $.ajax({
        type: 'get',
        url,
        success(data) {
            const response = JSON.parse(data);
            const parser = new DOMParser();
            const pageBuilder = parser.parseFromString(response.content, "text/html");

            document.body.appendChild(pageBuilder.body.firstChild);

            const editors = document.getElementsByClassName('js-page-builder');

            if (editors.length > 0) {
                import(/* webpackChunkName: "page-builder" */ './components/PageBuilder').then(
                    module => {
                        module.default(editors)
                    }
                );
            }

            InitializerEventDispatcher.dispatchEvent('ContentChanged');
        },
        error(request) {
            document.body.classList.remove('js-page-has-active-page-builder');

            if (request && 'responseJSON' in request) {
                import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                    module.default(request.responseJSON);
                });
            }
        }
    });
};

InitializerEventDispatcher.addEventListener('ContentChanged', () => {
    const regexTesterSelectors = document.getElementsByClassName('initializer--regex-tester');

    if (regexTesterSelectors.length > 0) {
        import(/* webpackChunkName: "regex-tester" */ './utils/RegexTester').then(module => {
            module.default(regexTesterSelectors);
        });
    }

    const selectors = document.getElementsByClassName('initializer--sortable-list');

    if (selectors.length > 0) {
        import(/* webpackChunkName: "sortable-list" */ './components/SortableList').then(module => {
            module.default(selectors);
        });
    }

    $('[data-change-visibility]').each((index, element) => {
        element.oldValue = element.checked;
    });
}, 100);

initLayout();

const $body = $('body');

/**
 * Open visual editor
 */
$body.on('click', '[data-page-builder-location]', (e) => {
    window.openPageEditor(e.currentTarget.getAttribute('data-page-builder-location'));
});

/**
 * Close visual editor and remove unused html
 */
$body.on('click', '.js--page-builder-close', () => {
    const pageBuilder = document.getElementById('PageBuilder');
    if (pageBuilder) {
        document.body.removeChild(pageBuilder);
    }

    const pageBuilderLoading = document.getElementById('page-builder-loading');
    if (pageBuilderLoading) {
        document.body.removeChild(pageBuilderLoading);
    }

    document.body.classList.remove('js-page-has-active-page-builder');
    $('.sp-hidden').remove();
});

$body.on('change', '[data-change-visibility]', {}, (e) => {
    if ('change_entity_visibility' in window) {
        window.change_entity_visibility.abort();
        delete window.change_entity_visibility;
    }

    const $target = $(e.currentTarget);

    let url = $target.attr('data-change-visibility');

    if ($target.attr('data-publish-with-post')) {
        window.change_entity_visibility = $.ajax({
            url,
            type: 'post',
            data: { state: e.currentTarget.checked ? 1 : 0 },
            success(data) {
                import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                    module.default(data);
                });

                e.currentTarget.oldValue = e.currentTarget.checked;
                if ('change_entity_visibility' in window) {
                    delete window.change_entity_visibility;
                }
            },
            error(request) {
                $target.prop("checked", e.currentTarget.oldValue);
                if (request && 'responseJSON' in request) {
                    import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                        module.default(request.responseJSON);
                    });
                }
            }
        });
    } else {
        if (e.currentTarget.checked) {
            url += '&state=1';
        } else {
            url += '&state=0';
        }

        window.change_entity_visibility = $.ajax({
            url,
            type: 'get',
            success(data) {
                import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                    module.default(data);
                });

                if ('change_entity_visibility' in window) {
                    delete window.change_entity_visibility;
                }
            },
            error(request) {
                if (request && 'responseJSON' in request) {
                    import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                        module.default(request.responseJSON);
                    });
                }
            }
        });
    }

    e.stopPropagation();

    return false;
});

$body.on('change', '.js--payment-method-leasing', {}, function() {
    if (this.checked) {
        import(/* webpackChunkName: "modal-box" */ './components/ModalBox').then(module => {
            module.ModalBox.open('/cms/payments/leasing/order');
        });
    }
});

$body.on('click', '[data-submit-basket-create-order]', {}, function() {
    $(this).addClass('is-loading');

    $.ajax({
        url: '/cms/documents/basket/submit?createOrder=1',
        type: 'post',
        dataType: 'json',
        success: (data) => {
            import(/* webpackChunkName: "request-response" */ './utils/RequestResponse').then(module => {
                module.default(data);
            });
        }
    });
});